import { HashrateItem } from "@components/Charts/ChartDatasetUtils";

export type IMathValues = [number, number, number, number]; // min, max, avg, length

export function getMathValues(hashrates: number[]): IMathValues { // min, max, avg
  let min = 0;
  let max = 0;
  let avg = 0;
  if (hashrates.length > 0) {
    min = hashrates[0];
    max = hashrates[0];
    avg = hashrates[0];
    for (let i = 1; i < hashrates.length; i++) {
      if (hashrates[i] < min) {
        min = hashrates[i];
      }
      if (hashrates[i] > max) {
        max = hashrates[i];
      }
      avg += hashrates[i];
    }
    avg = avg / hashrates.length;
  }
  return [min, max, avg, hashrates.length];
}

export function getMathValues2(hashrates: HashrateItem[]): IMathValues { // min, max, avg
  let min = 0;
  let max = 0;
  let avg = 0;
  if (hashrates && hashrates.length > 0) {
    min = hashrates[0].speed;
    max = hashrates[0].speed;
    avg = hashrates[0].speed;
    for (let i = 1; i < hashrates.length; i++) {
      if (hashrates[i].speed < min) {
        min = hashrates[i].speed;
      }
      if (hashrates[i].speed > max) {
        max = hashrates[i].speed;
      }
      avg += hashrates[i].speed;
    }
    avg = avg / hashrates.length;
  }
  return [min, max, avg, hashrates?.length ?? 0];
}

export function updateMathValues(
  value: number,
  before: IMathValues
): IMathValues {
  let min = before[0];
  let max = before[1];
  let avg = before[2];
  let length = before[3];
  if (value < min) min = value;
  if (value > max) max = value;
  avg = (avg * length + value) / (length + 1);
  return [min, max, avg, ++length];
}